module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/15EXaKu/tc-custom/9781459206717.jpg?1726444229060",
      "alt": "This image is the cover for the book Playboy King's Wife, Kings of the Outback"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Playboy King's Wife, Kings of the Outback\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Samantha Connelly finally knows what it is to feel sexy, elegant—and "), _c('i', [_vm._v("desirable")]), _vm._v(". Playboy Tommy King, the man she has secretly loved for years, is amazed at her transformation."), _c('br'), _c('br'), _vm._v("Up to now, Sam and Tommy have clashed head-on. Suddenly the friction deepens into fiery sexual attraction. But is this just another game for Tommy to win…or will Sam be the woman he marries?")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Emma Darcy\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Initially a French/English teacher, Emma Darcy changed careers to computer programming before the happy demands of marriage and motherhood. Very much a people person, and always interested in relationships, she finds the world of romance fiction a thrilling one and the challenge of creating her own cast of characters very addictive.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0